'use client';

import { useEffect, useState } from 'react';

/* The card hover shaders (Selected research, By the numbers) are desktop only:
   a real hover pointer on a desktop-width screen. Phones and tablets never mount
   them, and a tap doesn't fake a hover. False on the server and first render. */
const QUERY = '(min-width: 992px) and (hover: hover) and (pointer: fine)';

export function useHoverShaders(): boolean {
  const [on, setOn] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const sync = () => setOn(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);
  return on;
}
